<template>
  <div>
    <apexchart
      v-if="ready"
      width="100%"
      type="bar"
      :options="options"
      :series="series"
    ></apexchart>
    <center v-else>
      <strong>Não encontramos dados.</strong>
    </center>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";

export default {
  data: function () {
    return {
      options: {
        chart: {
          id: "clientes-por-interesse",
          animations: {
            speed: 200,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
        xaxis: {
          categories: [],
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#255aee",
            shadeTo: "dark",
            shadeIntensity: 0.5,
          },
        },
      },
      series: [
        {
          name: "interesses",
          data: [],
        },
      ],
      ready: false,
    };
  },
  methods: {
    async fillData() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-clientes-por-interesse/${localStorage
        .getItem("enterprise_id")
        .toString()}`;

      try {
        const response = await axios({
          url,
          methods: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          var array = response.data.data;
          for (let i = 0; i < array.length; i++) {
            const e = array[i];
            this.options.xaxis.categories.push(e.descricao);
            this.series[0].data.push(e.quantidade);
          }
          this.ready = true;
        }
      } catch (error) {
        console.log({ error });
      }
    },

  },
  async beforeMount() {
    await this.fillData();
  },
  mounted() {
    if (
      this.options.xaxis.categories.length > 0 &&
      this.series[0].data.length > 0
    )
      this.ready = true;
  },
};
</script>
